











































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";
import { ReservationDetail, Customer } from "@/model/ReservationDetail";
import { Uketsuke } from "@/model/Uketsuke";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import { ConfirmationBeforeEntry } from "@/model/ConfirmationBeforeEntry";
import * as util from "@/service/util";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputString from "@/components/common/input/InputString.vue";
import ReservationDetailState from "@/store/reservation/state";
import Header from "@/components/Header.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Staff } from "@/model/Staff";
import moment from "moment";
import { MESSAGE } from "@/model/Message";
import { CustomerService } from "@/service/CustomerService";
// import { ElForm } from "element-ui/types/form";
// import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
// import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { ElButton } from "element-ui/types/button";
import { SubHeaderData } from "@/model/SubHeaderData";
// import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { Support } from "@/model/Support";
import Number from "@/shared/filters/Number.ts";
import { kbnSkn } from "@/model/kbnSkn";
import { CarSelectData } from "@/model/CarSelection";
import InputCode from "@/components/common/input/InputCode.vue";
import InspectionDetailContent from "@/components/InspectionDetailContent.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { SeibiItem } from "@/model/InspectionSeibi";
import { ShakenShohiyou } from "@/model/shakenShohiyou";
import EstimateListComponent from "@/components/EstimateListComponent.vue";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import EstimateInspectionCostComponent from "@/components/EstimateInspectionCostComponent.vue";
import QuickCouponComponent from "@/components/QuickCouponComponent.vue";
import QuickOptionComponent from "@/components/QuickOptionComponent.vue";
import EstimatePreview from "@/components/EstimatePreview.vue";

const namespace: string = "ReservationDetail";
@Component({
  components: {
    Header,
    InputNumber,
    InputString,
    ConfirmDialog,
    InputCode,
    InspectionDetailContent
    , EstimateListComponent
    , EstimateInspectionCostComponent
    , QuickCouponComponent
    , QuickOptionComponent
    , EstimatePreview
  },
  filters: {
    Number
  }
})

/*================================================================= *
*  車検前画面
* ================================================================= */
export default class CustomerScreen extends Vue {
  @Prop() code: string;
  @State("ReservationDetail") state: ReservationDetail;
  @Action("init", { namespace })
  initStore: any;
  @Action("updateSoukouKm", { namespace })
  updateSoukouKm: any;
  @Action("updateSoukouKmAvg", { namespace })
  updateSoukouKmAvg: any;
  @Action("updateSoukouMile", { namespace })
  updateSoukouMile: any;
  @Action("updateSoukouMileAvg", { namespace })
  updateSoukouMileAvg: any;
  @Action("updateSoukouUnitKbn", { namespace })
  updateSoukouUnitKbn: any;
  @Action("updateSoukouBikouKbn", { namespace })
  updateSoukouBikouKbn: any;
  @Action("updateLaborRate", { namespace })
  updateLaborRate: any;
  @Action("initSupport", { namespace })
  initSupport: any;
  @Action("updateMemo", { namespace })
  updateMemo: any;
  @Action("updateFrontStaff", { namespace })
  updateFrontStaff: any;
  @Action("updateOmonaYouto", { namespace })
  updateOmonaYouto: any;
  @Getter("currentState", { namespace })
  currentState: ReservationDetailState;
  @Getter("uketsukeExtendsId", { namespace })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace })
  yoyakuNo: string;
  @Getter("frontStaff", { namespace })
  storeFrontStaff: string;
  @Getter("isLoadUketsuke", { namespace })
  isLoadUketsuke: boolean;

  @Action("setEnvironment", { namespace: "Environment" })
  setEnvironment: any;
  @Getter("environment", { namespace: "Environment" })
  environment: any;

  @Action("setTimeFromSubHeaderData", { namespace: "SubHeader" })
  setTimeFromSubHeaderData: any;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;
  @Getter("stateId", { namespace: "SubHeader" })
  workProgressStateId: any;

  @Action("updateConfirmation", { namespace })
  updateConfirmation: any;

  @Action("updateSoukou", { namespace: "CarSelection" })
  uptdateSoukouMD3: any;

  @Action("updateSoukouMile", { namespace: "CarSelection" })
  updateSoukouMileMD3: any;

  @Action("updateSoukouUnitKbn", { namespace: "CarSelection" })
  updateSoukouUnitKbnMD3: any;

  @Action("updateSoukouBikouKbn", { namespace: "CarSelection" })
  updateSoukouBikouKbnMD3: any;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;
  @Action("setState", { namespace: "CarSelection" })
  setCarSelection: any;

  @Action("clearState", { namespace: "InspectionDetail" })
  clearStateMD2: any;

  /** 2021-12-03 sh #7594 Not used. [START] */
  // @Getter("daisha", { namespace: "ReservationDetail" })
  // daisha: number;
  /** 2021-12-03 sh #7594 Not used. [END] */

  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [START] */
  @Action("setSeibiMenuCd", { namespace: "InspectionDetail" })
  setSeibiMenuCd: any;
  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [END] */

  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [END] */

  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  @Getter("isDoJizen", { namespace: "InspectionDetail" })
  isDoJizen: boolean;
  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  @Action("setJizenCd", { namespace: "InspectionDetail" })
  setJizenCd: any;
  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  finishLoad: boolean = false;
  isEdit: boolean = false;
  listTab: string[] = [];
  currentTab: number = 0;
  data: any = {};
  reqService: requestService;
  loadingService: loadingService = new loadingService();
  sktControll: SocketControllers;
  memo: string = "";
  timeoutMemo: any;
  staffs: Staff[] = [];
  frontStaff: string = "";
  frontStaffNm: string = "";
  isUserMode: boolean = false;
  soukouKm: number = 0;
  omonaYoutoCd: any = null;
  omonaYoutoNm: string = "";
  omonaYoutos: any[] = [];
  kbnConfirmations: any = [];
  timerWs: any = null;
  kyotenCd: string = "";
  isLoadConfirmation: boolean = false;
  confirmations: ConfirmationBeforeEntry[] = [];
  errorMsg: string = "";
  service: CustomerService;
  loadingText: string = MESSAGE.Loading;
  isRestart: boolean = false;
  displayDialogSupport: boolean = false;
  supportSelected: any = null;
  displayDialogUser: boolean = false;
  displayDialogLaborRate: boolean = false;
  offNotify: boolean = false;
  // laborRateKingakuZn: number| null = null;
  laborSelected: any = null;
  labors: any = [];
  soukouBikouList: any = [];
  soukouUnitList: any = [];
  soukouUnitKbn: number | null = null;
  soukouBikouKbn: number | null = null;
  soukouMile: number = 0;
  kbnJidousha: any = [];
  kbnSkns: kbnSkn[][] = [[], [], [], [], [], [], []];
  carForm: CarSelectData = {} as CarSelectData;
  kbnTitles: string[] = [
    "skn_youto",
    "skn_kudou_houshiki",
    "skn_fuel_kbn",
    "skn_shift_kbn",
    "skn_meter_panel_alert",
    "skn_brake",
    "skn_saitei_chijou_kou_kbn"
  ];
  shashuRenban: any = null;
  questionnaireList: any = [];
  timerGetQuestionare: any = null;
  reInitMd2: boolean = false;

  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [START] */
  loadingShakenShurui: boolean = false;
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */

  seibiList: any = [];
  shouhiyou: any = {
    houteiHiyou: {
      zeiJibaisekiZk: 0,
      zeiWeightTax: 0,
      zeiInshidaiZk: 0
    },
    kensaHiyou: {
      subTotalZk: 0
    },
    shakenHiyou: { subTotalZk: 0 }
  };
  showDialogEstimate: boolean = false;
  estData: any = {};
  inspectType: number = INSPECT_TYPE.RECOMMEND;
  estIssueAt: string = "";
  // 2022-01-31 morisako kobac-free add [START]
  freeOfChargeNm: string = '無償';
  freeOfChargeNm2: string = '対応';
  // 2022-01-31 morisako kobac-free add [END]

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  timeId: any = null;
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */

  $refs!: {
    memoDialog: ConfirmDialog;
    inputMemo: InputString;
    inputSoukouKm: InputNumber;
    startDialog: ConfirmDialog;
    errorDialog: ConfirmDialog;
    btnSoukouDialog: ElButton;
    inputSoukouKmDialog: InputNumber;
    inputLaborRateDialog: InputNumber;
    btnLaborRateDialog: ElButton;
    inspectionDetail: InspectionDetailContent;
    cancelDialog: ConfirmDialog;
    estimateInspectionCostComponent: EstimateInspectionCostComponent;
    quickCouponComponent: QuickCouponComponent;
    quickOptionComponent: QuickOptionComponent;
    estimateListComponent: EstimateListComponent;
    /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [START] */
    updateShakenShuruiDialog: ConfirmDialog;
    /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */
  };

  created() {
    this.clearStateMD2();
    this.reqService = new requestService();
    this.service = new CustomerService();
    this.sktControll = new SocketControllers();
    const kyoten = window.localStorage.getItem("kyotenCd");
    if (kyoten) {
      this.kyotenCd = kyoten;
    }

    if (this.$route.meta == "user") {
      this.isUserMode = true;
      this.listTab = [
        "予約情報",
        "概算見積",
        "車両情報",
        "アンケート",
        "検査構成"
        // "過去提案内容"
        // "車検整備履歴",
        // "一般整備履歴"
      ];
    } else {
      this.listTab = [
        "予約情報",
        "入庫前確認"
        // "過去提案内容"
        // "車検整備履歴",
        // "一般整備履歴"
      ];
    }

    this.reqService.getStaffFront().then(
      (res: any) => {
        if (res) {
          this.staffs = res;
          this.initFrontStaff();
        }
      },
      (err: any) => {
        this.staffs = [];
      }
    );

    this.reqService.getKbnSkns("skn_shiyou_youto").then(
      (res: any) => {
        if (res && res.length > 0) {
          this.omonaYoutos = res;
        }
      },
      (err: any) => {
        this.omonaYoutos = [];
      }
    );

    this.reqService.getKbnSkns("skn_confirmation_before_entry").then(
      (res: any) => {
        if (res) {
          this.kbnConfirmations = res;
          this.mapConfirmation();
        }
      },
      (err: any) => {
        this.kbnConfirmations = [];
      }
    );

    let kbn1 = this.reqService.getSoukouBikou().then(list => {
      this.soukouBikouList = list;
      this.setSoukouData();
    });
    let kbn2 = this.reqService.getSoukouUnit().then(list => {
      this.soukouUnitList = list;
      this.setSoukouData();
    });

    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
      },
      (err: any) => {}
    );

    let promise1 = this.reqService
      .getReservationDetail(this.code, this.isUserMode)
      .then(
        (res: any) => {
          if (res.header && res.header.login_group_code) {
            localStorage.setItem("groupCd", res.header.login_group_code[0]);
            localStorage.setItem("shatenCd", res.header.login_shaten_code[0]);
          }

          this.initStore(res);
          this.initData();
          this.getSupportData();
          this.finishLoad = true;
        },
        (err: any) => {
          this.finishLoad = true;
          this.showError(err);
        }
      );

    let promise2 = this.kbnTitles.map(async (kbn: string) => {
      return this.reqService.getKbnSkns(kbn);
    });
    Promise.all(promise2).then((res: any) => {
      this.$set(this, "kbnSkns", res);
    });
    Promise.all([promise1]).then(() => {
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then(
          (res: any) => {
            res.sknUketsukeExtendsId = +(this.uketsukeExtendsId);
            this.setCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
            this.carForm = this.carSelection;
            this.setDefaultBtn();
            this.shashuRenban = this.carForm.shashuRenban;
            this.setProgressState({
              stateId: res.sknWorkProgressState,
              stateNm: res.sknWorkProgressStateNm
            });
            /** 2021-11-30 sh #7584 added jizen check. [START] */
            if (this.isCanJizenMitsumori) {
              const userService = new UserService();
              userService.getAllData();
              this.shouhiyou = this.costData;
              this.getCompanyInfo();
              this.getJizenMitsumoriPreview();
              this.getJizenResult();
              this.getJizenInspectionSeibi();
            }
            /** 2021-11-30 sh #7584 added jizen check. [END] */
          },
          (err: any) => {
            console.log(err);
          }
        )
        .catch(error => {
          console.log(error);
        });
    });
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
  }

  setDefaultBtn() {
    //set default button value in carForm variable
    if (!this.carForm["shiftKbn"]) {
      this.carForm["shiftKbn"] = this.kbnSkns[3][0].kbnKey;
    }
    if (!this.carForm["kudouHoushiki"]) {
      this.carForm["kudouHoushiki"] = this.kbnSkns[1][0].kbnKey.toString();
    }
  }

  getSupportData() {
    let kokyakuKanriNo = "";
    if (this.uketsuke.kokyakuKanriNo) {
      kokyakuKanriNo = this.uketsuke.kokyakuKanriNo;
    }
    this.reqService.getSupport(kokyakuKanriNo).then((supports: any) => {
      if (supports.length) {
        this.initSupport(supports);
      }
    });
  }

  get uketsuke(): Uketsuke {
    if (this.currentState) {
      return this.currentState.uketsuke;
    }
    return {};
  }

  get sknUketsukeExtends() {
    if (this.currentState && this.currentState.sknUketsukeExtends) {
      return this.currentState.sknUketsukeExtends;
    }
    return {};
  }

  mapConfirmation() {
    if (this.kbnConfirmations.length > 0 && this.yoyakuNo) {
      this.confirmations = [];
      this.kbnConfirmations.forEach((e: any, i: number) => {
        let val = 0;
        if (this.sknUketsukeExtends) {
          const _val = (this.sknUketsukeExtends)[
            "confirmationBeforeEntry" + e.num
          ];
          if (_val) {
            val = _val;
          }
        }
        let entry: ConfirmationBeforeEntry = {
          num: e.num,
          id: this.uketsukeExtendsId,
          name: e.value,
          value: val,
          uketsukeCd: this.uketsukeCd,
          yoyakuNo: this.yoyakuNo
        };
        this.confirmations.push(entry);
      });
      this.isLoadConfirmation = true;
    }
  }

  onConnect() {
    if (this.uketsukeCd && this.uketsukeExtendsId) {
      if (this.sktControll.checkSocket()) {

        this.sktControll.socketConfirmation(this.onConfirmationBeforeEntry);
        this.sktControll.socketFront(this.onFrontStaff);
        if (this.isCanJizenMitsumori) {
          /** やりたいことは、再読込なので、流用する */
          this.sktControll.socketPayments(this.onPayments);
          this.sktControll.socketJizenRecommend(this.onPayments);
          this.sktControll.socketInspections(this.onPayments);
          this.sktControll.socketInspectSeibi(this.onPayments);
          if (this.isUserMode) {
            /** やりたいことは、再読込なので、流用する */
            this.sktControll.socketShohiyouCompleted(this.onPayments);
            this.sktControll.socketOption(this.onPayments);
            this.sktControll.socketCoupon(this.onPayments);
            this.sktControll.socketJizenDisplayOrder(this.onPayments);            
          }
        }

        if (this.isUserMode) {
          this.sktControll.socketShohiyouReload(this.socketShohiyouRollback);
          this.sktControll.socketReservation(this.onMileage);
          this.sktControll.socketReservationConfirmation(this.onMemo);
          this.sktControll.socketReservationInspection(this.onStartInspect);
          this.sktControll.socketQuestionnaireExtreme(this.onQuestionnaire);
          this.sktControll.socketExtends(this.onUpdateTime);
        } else {
          this.sktControll.socketCustomerYouto(this.onYouto);
        }
      }
      
    }
  }

  socketShohiyouRollback(frame: any){
    //複数のソケット通信をしているので処理をまとめる
    this.onReloadShouhiyou(frame);
    if (this.isCanJizenMitsumori) {
      this.onPaymentsBeforeRouteCheck(frame);
    }

  }

  mounted() {
    this.getQuestionare();
  }

  getQuestionare() {
    if (this.isUserMode) {
      this.timerGetQuestionare = setTimeout(() => {
        if (this.uketsukeExtendsId) {
          this.timerGetQuestionare = null;
          this.reqService
            .getQuestionnaireList(this.uketsukeExtendsId)
            .then((res: any) => {
              if (res) {
                const listQuestion = res.map((item:any) => {
                  const answer = item.answer.sort((a: any, b: any) => {
                    return a.displayOrder > b.displayOrder ? 1 : -1;
                  })
                  return { ...item, answer };
                });
                this.$set(this, "questionnaireList", listQuestion);
              }
            });
        } else {
          this.getQuestionare();
        }
      }, 1000);
    }
  }

  async setSoukouData() {
    if (this.sknUketsukeExtends.soukouBikouKbn) {
      this.soukouBikouKbn = +this.sknUketsukeExtends.soukouBikouKbn;
    } else if (this.soukouBikouList.length > 0) {
      this.soukouBikouKbn = +this.soukouBikouList[0].kbn;
    }
    if (this.sknUketsukeExtends.soukouUnitKbn) {
      this.soukouUnitKbn = +this.sknUketsukeExtends.soukouUnitKbn;
    } else if (this.soukouUnitList.length > 0) {
      this.soukouUnitKbn = +this.soukouUnitList[0].kbn;
    }
    this.updateSoukouUnitKbn(this.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.soukouBikouKbn);
    this.updateSoukouUnitKbnMD3(this.soukouUnitKbn);
    this.updateSoukouBikouKbnMD3(this.soukouBikouKbn);
    if (this.soukouKm && !this.soukouMile) {
      await this.onFocusoutSoukouKm();
    } else if (this.soukouMile && !this.soukouKm) {
      await this.onFocusoutSoukouMile();
    }
  }

  onFocusoutSoukouKm() {
    const tempKm: number = this.soukouKm ? +this.soukouKm : 0;
    return this.reqService.convertMiles_Km(tempKm, "2").then((mile: any) => {
      if (mile) {
        this.soukouMile = mile.miles ? mile.miles : 0;
        this.updateSoukouMile(this.soukouMile);
        this.updateSoukouMileMD3(this.soukouMile);
      }
    });
  }

  onFocusoutSoukouMile() {
    const tempMile: number = this.soukouMile ? +this.soukouMile : 0;
    return this.reqService.convertMiles_Km(tempMile, "1").then((km: any) => {
      if (km) {
        this.soukouKm = km.km ? km.km : 0;
        this.updateSoukouKm(this.soukouKm);
        this.uptdateSoukouMD3(this.soukouKm);
      }
    });
  }

  initData() {
    this.sktControll.connectSocket(this.onConnect);
    if (this.sknUketsukeExtends) {
      this.getWorkProgressState();
      if (this.sknUketsukeExtends.sknMemo) {
        this.memo = this.sknUketsukeExtends.sknMemo;
      }
      if (this.sknUketsukeExtends.soukouKm) {
        this.soukouKm = this.sknUketsukeExtends.soukouKm;
      }
      if (this.sknUketsukeExtends.soukouMile) {
        this.soukouMile = this.sknUketsukeExtends.soukouMile;
      }
      this.setSoukouData();
      if (this.sknUketsukeExtends.omonaYouto) {
        this.omonaYoutoCd = this.sknUketsukeExtends.omonaYouto;
        // this.$set(this, "omonaYoutoCd", this.sknUketsukeExtends.omonaYouto)
        if (this.sknUketsukeExtends.omonaYoutoNm) {
          this.omonaYoutoNm = this.sknUketsukeExtends.omonaYoutoNm;
        }
      }
      if (this.isUserMode) {
        this.displayDialogUser = true;
      }
      this.initFrontStaff();
    }
    setTimeout(() => {
      if (this.uketsukeCd) {
        this.mapConfirmation();
      }
    }, 250);
  }

  initFrontStaff() {
    if (
      this.sknUketsukeExtends.frontTantoushaCd &&
      this.sknUketsukeExtends.frontTantoushaNm &&
      this.staffs.length > 0 &&
      this.frontStaff != this.sknUketsukeExtends.frontTantoushaCd
    ) {
      let selectedStaff = this.staffs.find(
        (staff: Staff) =>
          staff.staffCd == this.sknUketsukeExtends.frontTantoushaCd
      );
      if (selectedStaff == null) {
        const staff: Staff = {
          staffCd: this.sknUketsukeExtends.frontTantoushaCd,
          staffNm: this.sknUketsukeExtends.frontTantoushaNm,
          kyotenCd: "",
          kyotenNm: ""
        };
        this.staffs.splice(0, 0, staff);
      }
      this.frontStaff = this.sknUketsukeExtends.frontTantoushaCd;
      this.frontStaffNm = this.storeFrontStaff;
      this.onUpdateFront(this.frontStaff);
    }
  }

  get customer() {
    if (this.currentState && this.currentState.customer) {
      return this.currentState.customer;
    }
    return {};
  }
  get customerCar() {
    if (this.currentState && this.currentState.customerCar) {
      return this.currentState.customerCar;
    }
    return {};
  }

  get support() {
    if (this.currentState) {
      return this.currentState.support;
    }
    return false;
  }

  getDate(strDate: string) {
    if (strDate) {
      return util.formatDate(strDate, "M/D");
    }
    return "";
  }
  getTime(strTime: string) {
    if (strTime) {
      return util.removeLeadingZero(strTime);
    }
    return "";
  }
  selectTab(tab: any, index: number) {
    if (index !== this.currentTab) {
      this.currentTab = index;
      if (index == 3 && this.reInitMd2) {
        this.resetMd2();
      }
    }
  }
  get visibleTabReserve() {
    if (this.isUserMode && this.currentTab == 2) {
      return false;
    }
    return (
      (this.currentTab == 0 || this.currentTab == 2 || this.currentTab == 3) &&
      this.finishLoad &&
      this.uketsukeExtendsId
    );
  }
  isActive(index: number) {
    return this.currentTab === index;
  }

  // isFutureDate() {
  //   let today = moment();
  //   if (this.uketsuke.workPlansYmd) {
  //     let datePlan = moment(this.uketsuke.workPlansYmd);
  //     if (datePlan.isAfter(today)) {
  //       this.errorMsg = MESSAGE.AlertFutureDate;
  //       this.$refs.errorDialog.onOpen();
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  onInspection() {
    if(this.finishLoad){
      //factory
      if (this.isNoLaborRate) {
        this.displayDialogLaborRate = true;
        return;
      }
      // if (!this.isFutureDate()) {
      // if (!this.sknUketsukeExtends.soukouKm) {
      //   this.$refs.inputSoukouKm.focus();
      //   this.$message({
      //     message: MESSAGE.SoukouKmNotEntered,
      //     type: "error"
      //   });
      // } else {
        this.nextPage();
      // }
      // }
    }
  }

  nextPage() {
    this.$router.push({ name: "inspectiondetail" });
  }

  onStart() {
    //user
    // if (!this.isFutureDate()) {
      const userService = new UserService();
      if (
        !this.currentState.sknUketsukeExtends ||
        !this.currentState.sknUketsukeExtends.ryoukinRankCd
      ) {
        userService.getAllData(false);
      } else {
        userService.getAllData();
      }
      this.$router.push({ name: "statusresult" });
    // }
  }

  getStrLastMileage() {
    if (this.sknUketsukeExtends.zenkaiSoukouKm) {
      const km: number = +(this.sknUketsukeExtends.zenkaiSoukouKm);
      return util.getNumberThousandSeparate(km) + "km";
    }
    return "";
  }
  heiseiDate(date: string) {
    return util.getJapanDate(date, "YYYYMMDD");
  }

  async onChangeSoukoukm() {
    let soukouKmAvg = util.calSoukouAvg(
      this.soukouKm,
      this.sknUketsukeExtends,
      this.uketsuke
    );
    let soukouMileAvg = util.calSoukouMileAvg(
      this.soukouMile || 0,
      this.sknUketsukeExtends,
      this.uketsuke,
    );
    try {
      if (this.soukouUnitKbn == 1) {
        await this.onFocusoutSoukouKm();
      } else {
        await this.onFocusoutSoukouMile();
      }
    } catch (e) {
      console.log("error: cannot convert soukou")
    }
    this.updateSoukouKm(this.soukouKm);
    this.updateSoukouKmAvg(soukouKmAvg);
    this.updateSoukouMileAvg(soukouMileAvg);
    this.uptdateSoukouMD3(this.soukouKm);
    this.updateSoukouMile(this.soukouMile);
    this.updateSoukouMileMD3(this.soukouMile);
    this.updateSoukouUnitKbn(this.soukouUnitKbn);
    this.updateSoukouUnitKbnMD3(this.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.soukouBikouKbn);
    this.updateSoukouBikouKbnMD3(this.soukouBikouKbn);
    this.reqService.saveMileage(
      this.service.getPutParams({
        soukouKm: this.soukouKm,
        soukouKmAvg,
        soukouMile: this.soukouMile,
        soukouMileAvg,
        soukouUnitKbn: this.soukouUnitKbn,
        soukouBikouKbn: this.soukouBikouKbn
      })).then(
      (res: any) => {
        this.$message({
          message: MESSAGE.UpdatedSoukouKm,
          type: "info"
        });
      }, (err: any) => {
        this.showError(err);
      });
  }

  saveLaborRate() {
    let laborSelected = this.labors.find(
      (e: any) => e.laborRateCd == this.laborSelected
    );
    if (this.laborSelected && laborSelected) {
      this.reqService
        .saveRateKingakuZn({
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          laborRateKingakuZn: laborSelected.shakenTenken,
          laborRateCd: laborSelected.laborRateCd
        })
        .then(
          (res: any) => {
            this.updateLaborRate(laborSelected.shakenTenken);
            this.displayDialogLaborRate = false;
          },
          (err: any) => {
            this.showError(err);
          }
        );
    }
  }

  onOpenDialogLaborate() {
    setTimeout(() => {
      this.$refs.btnLaborRateDialog.$el.focus();
    }, 0);
  }

  closeWarningLaborate() {
    this.displayDialogLaborRate = false;
  }

  getFullDate(date: string, format: string) {
    const formatDate = format ? format : "YYYYMMDD";
    if (date) {
      return util.getFullDate(date, formatDate);
    } else {
      return "";
    }
  }

  memoEditMode() {
    this.isEdit = true;
    setTimeout(() => {
      this.$refs.inputMemo.focus();
    }, 100);
  }

  editMemo() {
    if (this.isEdit) {
      if (this.timeoutMemo) {
        clearTimeout(this.timeoutMemo);
        this.timeoutMemo = null;
      }
      this.onSaveMemo();
    } else {
      this.memoEditMode();
    }
  }

  onFocusoutMemo(value: string) {
    this.memo = value;
    this.timeoutMemo = setTimeout(() => {
      if (this.memo != this.sknUketsukeExtends.sknMemo) {
        this.$refs.memoDialog.onOpen();
      } else {
        this.onCancelMemo();
      }
    }, 500);
  }

  onSaveMemo() {
    this.updateMemo(this.memo);
    this.reqService
      .saveMemo(this.service.getPutParams({ sknMemo: this.memo }))
      .then(
        (res: any) => {
          this.$message({
            message: MESSAGE.UpdatedMemo,
            type: "info"
          });
        },
        (err: any) => {
          this.showError(err);
        }
      );

    this.isEdit = false;
  }

  onCancelMemo() {
    if (this.sknUketsukeExtends.sknMemo) {
      this.memo = this.sknUketsukeExtends.sknMemo;
    } else {
      this.memo = "";
    }

    this.isEdit = false;
  }

  onCloseDialogMemo() {
    this.$refs.inputMemo.focus();
  }

  getDaisha() {
    // if (this.uketsuke.daisha && Object.keys(this.uketsuke.daisha).length > 0) {
    //   return "あり";
    // }
    if (this.uketsuke.daishaRequireKbn === 1) {
      return "あり";
    }
    return "なし";
  }

  get IsHoujin(): boolean {
    if (this.uketsuke) {
      return this.uketsuke.kkKbn == 2;
    }
    return false;
  }

  getAddress() {
    let zipno = this.uketsuke.kkZipNo;
    if (zipno && zipno.length > 3) {
      zipno = zipno.replace(/\b(\d{3})/g, "$1-");
    }
    return (
      "〒" +
      zipno +
      " " +
      this.uketsuke.kkPrefNm +
      this.uketsuke.kkAddr1 +
      this.uketsuke.kkAddr2
    );
  }

  setConfirm(index: number, val: number) {
    this.offNotify = true;
    // if (this.isUserMode) {
    if (this.confirmations[index].value == val) {
      val = 0;
    }
    this.confirmations[index].value = val;
    this.updateConfirmation({ num: index + 1, value: val });
    this.reqService.saveConfirmation(this.confirmations[index]).then(
      (res: any) => {},
      (err: any) => {
        this.showError(err);
      }
    );
    // }
  }
  getClassConfirm(index: number, val: number) {
    let cssClass = "";
    // if (!this.isUserMode) {
    //   cssClass = "disabled ";
    // }
    if (this.confirmations.length != 0) {
      if (this.confirmations[index].value == val) {
        cssClass += "primary-pushed";
      } else {
        cssClass += "normal";
      }
    }
    return cssClass;
  }

  shortHistoryTitle(title: string, i: number) {
    title = title.replace(/\\n/g, " ");
    const titleLength = util.getUTF8Length(title, 80);
    if (
      titleLength.count > 80 &&
      (this.supportSelected === null ||
        (this.supportSelected && this.supportSelected.index != i))
    ) {
      return title.substr(0, titleLength.strCount) + "...";
    } else {
      return title;
    }
  }

  showMore(item: string, i: number) {
    let title = item.replace(/\\n/g, " ");
    const titleLength = util.getUTF8Length(title, 80);
    if (
      titleLength.count > 80 &&
      (this.supportSelected === null ||
        (this.supportSelected && this.supportSelected.index != i))
    ) {
      return true;
    } else {
      return false;
    }
  }

  showLess(item: string, i: number) {
    let title = item.replace(/\\n/g, " ");
    const titleLength = util.getUTF8Length(title, 80);
    if (titleLength.count > 80) {
      return true;
    } else {
      return false;
    }
  }

  getSelectedStaff(staffCd: string) {
    let selectedStaff = this.staffs.filter(
      (staff: Staff) => staff.staffCd == staffCd
    );
    if (selectedStaff.length > 0) {
      return selectedStaff[0];
    }
  }

  onUpdateFront(value: string, sendAPI?: boolean) {
    if (this.frontStaff) {
      let selectedStaff = this.staffs.filter(
        (staff: Staff) => staff.staffCd == value
      );
      if (selectedStaff.length > 0) {
        this.frontStaffNm = selectedStaff[0].staffNm;
        this.updateFrontStaff({
          staffCd: value,
          staffNm: this.frontStaffNm
        });
        if (sendAPI) {
          this.offNotify = true;
          this.reqService
            .saveFrontTantousha(
              this.service.getPutParams({ frontTantoushaCd: this.frontStaff })
            )
            .then(
              (res: any) => {
                this.$message({
                  message: MESSAGE.UpdatedFrontTantousha,
                  type: "info"
                });
              },
              (err: any) => {
                this.showError(err);
              }
            );
        }
      }
    }
  }
  getTopic(index: number) {
    if (this.confirmations.length !== 0) {
      if (this.confirmations.length > index) {
        return this.confirmations[index].name;
      }
    } else if (this.kbnConfirmations.length > 0) {
      return this.kbnConfirmations[index].value;
    }
    return "";
  }

  getButtonName(index: number, isConfirm: boolean = true) {
    const arrNum = [0, 1, 2];
    if (arrNum.indexOf(index) > -1) {
      if (isConfirm) {
        return "確認";
      }
      return "未確認";
    } else {
      if (isConfirm) {
        return "あり";
      }
      return "なし";
    }
  }

  filterYouto() {
    return this.omonaYoutos.filter((e: any) => e.kbnKey === this.omonaYoutoCd);
  }

  updateStoreYouto() {
    this.updateOmonaYouto({
      omonaYouto: this.omonaYoutoCd,
      omonaYoutoNm: this.omonaYoutoNm
    });
  }

  changeOmonaYouto(value: any) {
    if (value) {
      const omonaYouto = this.filterYouto();
      if (omonaYouto.length > 0) {
        this.omonaYoutoNm = omonaYouto[0].value;
        this.updateStoreYouto();
        this.reqService
          .saveOmonaYouto(
            this.service.getPutParams({ omonaYouto: omonaYouto[0].kbnKey })
          )
          .then(
            (res: any) => {
              this.$message({
                message: MESSAGE.UpdatedOmonaYouto,
                type: "info"
              });
            },
            (err: any) => {
              this.showError(err);
            }
          );
      }
    }
  }

  onUpdateTime(frame: any) {
    const body = util.getWSData(frame);
    if (body.screenId == "1" && this.isUserMode) {
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then((res: any) => {
          res.sknUketsukeExtendsId = +(this.uketsukeExtendsId);
          this.setCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
          this.carForm = this.carSelection;
        });
    }
  }

  onMileage(frame: any) {
    const body = util.getWSData(frame);
    this.soukouKm = +body.soukouKm;
    this.soukouMile = +body.soukouMile;
    this.soukouUnitKbn = +body.soukouUnitKbn;
    this.soukouBikouKbn = +body.soukouBikouKbn;
    this.updateSoukouKm(this.soukouKm);
    this.uptdateSoukouMD3(this.soukouKm);
    this.updateSoukouMile(this.soukouMile);
    this.updateSoukouMileMD3(this.soukouMile);
    this.updateSoukouUnitKbn(this.soukouUnitKbn);
    this.updateSoukouUnitKbnMD3(this.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.soukouBikouKbn);
    this.updateSoukouBikouKbnMD3(this.soukouBikouKbn);
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedSoukouKm
    });
  }

  onMemo(frame: any) {
    const body = util.getWSData(frame);
    this.memo = body.sknMemo;
    this.updateMemo(this.memo);
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedMemo
    });
  }

  onConfirmationBeforeEntry(frame: any) {
    if (this.offNotify) {
      this.offNotify = false;
    } else {
      const body = util.getWSData(frame);
      const index = body.num - 1;
      this.confirmations[index].value = body.value;
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedConfirmationBeforeEntry
      });
    }
  }

  onYouto(frame: any) {
    const body = util.getWSData(frame);
    this.omonaYoutoCd = body.omonaYouto;
    this.omonaYoutoNm = body.omonaYoutoNm;
    this.updateStoreYouto();
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedOmonaYouto
    });
  }

  onEnterSoukoukm() {
    this.$refs.inputSoukouKm.blur();
  }

  resetMd2() {
    this.clearStateMD2();
    this.$refs.inspectionDetail.initData();
    this.$forceUpdate();
  }

  onStartInspect(frame: any) {
    const body = util.getWSData(frame);
    if (this.$refs.startDialog) {
      this.$refs.startDialog.onOpen();
    }
    if (this.currentTab == 4) {
      this.resetMd2();
    } else {
      this.reInitMd2 = true;
    }

    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    if (body && body.seibiMenuCd) {
      this.setSeibiMenuCd(body.seibiMenuCd);
    }
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }

  onFrontStaff(frame: any) {
    if (this.offNotify) {
      this.offNotify = false;
    } else {
      const body = util.getWSData(frame);
      this.$set(this, "frontStaff", body.frontTantoushaCd);
      this.onUpdateFront(body.frontTantoushaCd, false);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedFrontTantousha
      });
    }
  }

  onQuestionnaire(frame: any) {
    const body = util.getWSData(frame);
    this.questionnaireList = body;
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedQuestionnaire
    });
  }

  showError(error: any) {
    this.errorMsg = util.getHttpErrorMessage(error);
    this.$refs.errorDialog.onOpen();
  }

  getWorkProgressState() {
    this.reqService
      .getSubHeaderData(this.uketsukeExtendsId, this.$route.meta)
      .then(
        (res: SubHeaderData) => {
          this.setProgressState({
            stateId: res.sknWorkProgressStateId,
            stateNm: res.sknWorkProgressStateNm
          });

          if (res.sknWorkProgressStateId && res.sknWorkProgressStateId > 0) {
            this.isRestart = true;
          }
          if (!this.isUserMode && this.isNoLaborRate) {
            this.reqService.getLaborRate().then((res: any) => {
              if (res && res.length > 0) {
                this.$set(this, "labors", res);
              }
            });
          }
        },
        (err: any) => {}
      );
  }

  get showConfirmation() {
    if (!this.isLoadConfirmation) {
      return false;
    }
    if (this.isUserMode && this.currentTab != 3) {
      return true;
    } else if (this.currentTab == 2) {
      return true;
    }
    return false;
  }
  get showSupport() {
    if (this.isUserMode) {
      return false;
    } else if (this.currentTab == 0) {
      return true;
    }
    return false;
  }

  showSupportSelected(item: any, i: number) {
    this.supportSelected = { ...item, index: i };
    // this.displayDialogSupport = true;
  }

  closeDialogSupport() {
    this.supportSelected = null;
    // this.displayDialogSupport = false;
  }

  get isNoLaborRate() {
    if (this.sknUketsukeExtends) {
      if (this.sknUketsukeExtends.laborRateCd) {
        //削除済みや未登録のコード指定だと、コードだけ格納されていてこの先動作しないので追加でチェックする
        if (this.sknUketsukeExtends.laborRateKingakuZn) {
          return false;
        } else {
          return true;
        }
      } else {
        //レバレートコードもレバレート金額も未設定なら選択させる
        if (this.sknUketsukeExtends.laborRateKingakuZn) {
          return false;
        } else {
          return true;
        }
      }
    }
    return true;
  }

  // get isAvailableSoukou() {
  //   if (this.sknUketsukeExtends.zenkaiSoukouKm) {
  //     if (this.sknUketsukeExtends.zenkaiSoukouKm < this.soukouKm) {
  //       return true;
  //     }
  //   } else {
  //     return true;
  //   }
  //   return false;
  // }
  // get disabledSaveSoukou() {
  //   if (this.workProgressStateId == 0) {
  //     return false;
  //   }
  //   if (this.isAvailableSoukou) {
  //     return false;
  //   }
  //   return true;
  // }

  onEnterSoukoukmDialog() {
    this.$refs.inputSoukouKmDialog.blur();
    setTimeout(() => {
      this.$refs.btnSoukouDialog.$el.focus();
    }, 100);
  }

  // onEnterLaborRateDialog() {
  //   this.$refs.inputLaborRateDialog.blur();
  //   setTimeout(() => {
  //     this.$refs.btnLaborRateDialog.$el.focus();
  //   }, 100);
  // }

  laborRateLabel(labor: any) {
    return (
      labor.bunruiNm + " " + util.getNumberThousandSeparate(labor.shakenTenken)
    );
  }

  activeKudouHoushiki(kbn: kbnSkn) {
    if (!this.carForm.kudouHoushiki) {
      return kbn.num == 1;
    } else {
      return +this.carForm.kudouHoushiki == kbn.kbnKey;
    }
  }

  activeShift(kbn: kbnSkn) {
    if (!this.carForm.shiftKbn) {
      return kbn.num == 1;
    } else {
      return +this.carForm.shiftKbn == kbn.kbnKey;
    }
  }

  saveQuestionnaire() {
    this.reqService.saveQuestionnaire(this.questionnaireList);
  }

  destroyed() {
    this.sktControll.freeSocketResources();

    if (this.timerGetQuestionare) {
      clearTimeout(this.timerGetQuestionare);
    }
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      if (this.isUserMode) {
        this.$router.push({ name: "reservationNumber" });
      } else {
        this.$router.push({ name: "reservation" });
      }
    });
  }

//  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
//  sumPrice!: (inspectType: number) => any;
  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];
  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;
  @Getter("total", { namespace: "Coupon" })
  couponData: any;
  @Getter("total", { namespace: "Option" })
  optionData: any;
  listPrefectures: any = {};
  companyInfo: any = {};
  showDialogInspectionCost: boolean = false;
  showDialogCoupon: boolean = false;
  showDialogOption: boolean = false;
  showDialogPreview: boolean = false;

  get calcTotal2() {
    let total = 0;
    this.seibiList.forEach((elm: any) => {
        let itemTotal = this.sumItem(elm);
        total += itemTotal;
    });
    return total;
  }

  getRecommendTotalZk() {
    let recommendSeibiList = this.listInspect(INSPECT_TYPE.RECOMMEND);
    let totalZk = recommendSeibiList.reduce(
      (sum: number, cur: any) =>
        sum + ((cur.buhinEditTotalZk ? cur.buhinEditTotalZk < 0 ? 0: cur.buhinEditTotalZk: 0) || 0) + ((cur.kouchinEditZk ? cur.kouchinEditZk < 0 ? 0: cur.kouchinEditZk: 0) || 0),
      0
    );
    return totalZk;
  }

  get couponZk() {
    if (!this.couponData) {
      return 0;
    }
    return this.couponData.subTotalZk;
  }

  get optionZk() {
    if (!this.optionData) {
      return 0;
    }
    return this.optionData.subTotalZk;
  }

  get calcTotal1() {
    /** 2021-08-23 sh #7361 change grandTotal from calculate to reference. [START] */
    /**
    return (
      this.shouhiyou.kensaHiyou.subTotalZk +
      this.shouhiyou.houteiHiyou.zeiJibaisekiZk +
      this.shouhiyou.houteiHiyou.zeiWeightTax +
      this.shouhiyou.houteiHiyou.zeiInshidaiZk +
      this.shouhiyou.shakenHiyou.subTotalZk +
      this.optionZk + this.couponZk + this.calcTotal2
    );
    */
    return this.data.calcTotal;
    /** 2021-08-23 sh #7361 change grandTotal from calculate to reference. [END] */
  }

  onShowDialogEstimate() {
    this.getJizenInspectionSeibi();
    this.getJizenMitsumoriPreview();
    this.showDialogEstimate = true;
  }

  setSeibiData() {
    this.estData.forEach((element: any) => {
      if (element.osusume) {
        if (element.recommend && element.recommend.length > 0) {
          element.recommend.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      } else {
        if (element.subItems && element.subItems.length > 0) {
          element.subItems.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      }
    });
  }

  onCloseDialogEstimate() {
    this.getJizenInspectionSeibi();
    this.getJizenMitsumoriPreview();
    this.showDialogEstimate = false;
  }

  isTriangle(item: any) {
    return item.inspectResult == InspectButtonValue.TRIANGLE;
  }

  isCross(item: any) {
    return item.inspectResult == InspectButtonValue.CROSS;
  }

  sumItem(item: any) {
    /** 2023-10-19 invoice [START] */
    return this.isExcludingTax? (item.buhinEditTotalZn || 0) + ( item.kouchinEditZn || 0) : (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
    /** 2023-10-19 invoice [END] */
  }

  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [START] */
  onReloadShouhiyou(frame: any) {
    const body = util.getWSData(frame);
    if (body.shakenShuruiSeibiMenuCd) {
      this.setSeibiMenuCd(body.shakenShuruiSeibiMenuCd);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedShakenCouse
      });
    }
  }
  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [END] */
  getCompanyInfo() {
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;

      this.reqService.getCompanyInfo().then((res)=> {
        if(res) {
          this.companyInfo = res;

          const pref = this.listPrefectures.filter( (e: any) => e.prefCd == this.companyInfo.prefCd );
          if (pref && pref.length > 0) {
            this.companyInfo.prefNm = pref[0].prefNm;
          }
        }
      }, (err: any) => {
        this.companyInfo = {
          zip1: null,
          zip2: null,
          prefCd: null,
          prefNm: null,
          addr1: null,
          addr2: null,
          shatenNm: null,
          kyotenNm: null,
          tel1: null,
          tel2: null,
          tel3: null,
          lineQr: null
        };
      });
    });
  }

  getJizenMitsumoriPreview() {
    this.reqService.getJizenMitsumoriPreview(this.uketsukeExtendsId).then(
      (res: any) => {
        let shakenHiyouItem = [];
        if (res.shakenHiyouItems) {
          shakenHiyouItem = res.shakenHiyouItems.filter((item: any, index: number) => {
            return index === res.shakenHiyouItems.findIndex((obj: any) => {
              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
            }) && item.shohiyouNm != '';
          });
        }
        res.shakenHiyouItems = shakenHiyouItem;
        /** 2021-08-24 sh #7361 fix bug. it does not reactive. [START] */
        // this.data = res;
        this.$set(this, "data", []);
        this.$set(this, "data", res);
        if (this.$refs.estimateInspectionCostComponent
        && typeof this.$refs.estimateInspectionCostComponent.onUpdateShohiyou === 'function' ) {
          this.$refs.estimateInspectionCostComponent.onUpdateShohiyou();
        }
        /** 2021-08-24 sh #7361 fix bug. it does not reactive. [END] */

        /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
        this.onUpdateCoupon();
        this.onUpdateOption();
        /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

      },
      (err: any) => {
      }
    );
  }

  getJizenResult() {
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.setLoadingShakenShurui(true);
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    this.reqService.getJizenResult(this.uketsukeExtendsId).then(
      (res: any) => {
        this.estIssueAt = res.estIssueAt;
        this.estData = res.jizenResult;
        if (this.estData && this.estData.length > 0) {
          if (this.estData[0].osusume) {
            this.inspectType = INSPECT_TYPE.RECOMMEND;
          } else {
            this.inspectType = INSPECT_TYPE.LEGAL56;
          }
          this.setSeibiData();
          /** 2021-08-20 sh #7356  send message to customer-screen. [START] */
          if (this.isCanJizenMitsumori
            && this.$refs.estimateListComponent
            && typeof this.$refs.estimateListComponent.updateCurrentData === 'function') {
            this.$refs.estimateListComponent.updateCurrentData();
          }
          /** 2021-08-20 sh #7356  send message to customer-screen. [END] */
          /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
          /** する・しない・後日を押した場合、データを取得しなおしているので、子画面が開いていたら、スクロールさせる */
          if (this.showDialogEstimate) {
            this.$refs.estimateListComponent.scrollToCurrentIndex();
          }
          /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
        }
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        this.setLoadingShakenShurui(false);
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
      },
      (err: any) => {
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        this.setLoadingShakenShurui(false);
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
      }
    );
  }

  getJizenInspectionSeibi() {
    this.reqService.getJizenInspectionSeibi(this.uketsukeExtendsId).then(
      (res: any) => {
        this.seibiList = res;
      },
      (err: any) => {
      }
    );
  }

  onShowDialogInspectionCost() {
    this.showDialogInspectionCost = true;
  }

  onCloseDialogInspectionCost() {
    this.$refs.estimateInspectionCostComponent.onConfirm();
    this.getJizenMitsumoriPreview();
    this.showDialogInspectionCost = false;
  }

  onShowDialogCoupon() {
    this.showDialogCoupon = true;
  }

  onCloseDialogCoupon() {
    this.$refs.quickCouponComponent.onConfirm(1);
    /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [START] */
    //this.getJizenMitsumoriPreview();
    //this.showDialogCoupon = false;
  }

  onCloseDialogCouponNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogCoupon = false;
    /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [END] */
  }

  onShowDialogOption() {
    this.showDialogOption = true;
  }

  onCloseDialogOption() {
    this.$refs.quickOptionComponent.onConfirm(1);
    /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
    //this.getJizenMitsumoriPreview();
    //this.showDialogOption = false;
  }

  onCloseDialogOptionNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogOption = false;
    /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
  }

  onShowPrintJizenMitsumori() {
    this.showDialogPreview = true;
  }

  onCloseDialogPreview() {
    this.showDialogPreview = false;
  }

  onPrintJizenMitsumori() {
    this.loadingService.show();
    this.reqService.getSknEstimate(this.uketsukeExtendsId).then((blob: any) => {
      this.loadingService.hide();
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = '概算車検見積書.pdf'; // 2021-11-10 sh #7536 change name from 車検見積結果 to 概算車検見積書
      link.click();
    });
  }

  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [START] */
  onPayments(){
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    // this.$notify.info({
    //  title: "Info",
    //  message: MESSAGE.UpdatedJizenEstimate
    // });
    // this.getJizenMitsumoriPreview();
    // this.getJizenResult();
    // this.getJizenInspectionSeibi();
    clearTimeout(this.timeId);
    this.timeId = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedJizenEstimate
      });
      this.getJizenMitsumoriPreview();
      this.getJizenResult();
      this.getJizenInspectionSeibi();
    }, 1500);
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  }
  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [END] */

  /** 2021-08-30 sh #7360 if jizen mitsumori is off, remove jizen-mitsumori from listTab. [START] */
  isTabNotShow(index: any) {
    if(index==1) {
      /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
      // if(!this.isCanJizenMitsumori){
      //   return true;
      // }
      if(!this.checkIsCanJizen()){
        return true;
      }
      /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */
    }
    return false;
  }
  /** 2021-08-30 sh #7360 if jizen mitsumori is off, remove jizen-mitsumori from listTab. [END] */

  /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
  onUpdateCoupon() {
    const userService = new UserService();
    userService.getCoupon();
  }
  onUpdateOption() {
    const userService = new UserService();
    userService.getOption();
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  checkIsCanJizen() {
    // console.log("workOrder.checkIsCanJizen isDoJizen => ", this.isDoJizen);
    // console.log("workOrder.checkIsCanJizen isCanJizenMitsumori => ", this.isCanJizenMitsumori);
    return this.isCanJizenMitsumori && this.isDoJizen;
  }
  /** 2021-09-10 sh #7396 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  /** 2021-10-05 sh #7438 implements tech info amount. [START] */
  get isUseTechInfoAmount() {
    return this.data.isUseTechInfoAmount == 1;
  }
  /** 2021-10-05 sh #7438 implements tech info amount. [END] */

  /** 2021-10-25 sh #7493 change display of spec. [START] */
  isNotRecommend(item: any) {
    return !(item.sknInspectId == null);
  }
  /** 2021-10-25 sh #7493 change display of spec. [END] */
  onCancelStart() {
      this.reqService
        .getInsectionDetail(this.uketsukeExtendsId)
        .then((data: any) => {
          this.setJizenCd(data.jizenCd);
          let div = document.getElementById("listTab_1");
          if (div) {
            if (this.checkIsCanJizen()) {
              div.classList.remove('tab_not_show');
            } else {
              div.classList.add('tab_not_show');
            }
          }
          this.currentTab = 0;
        });
  }
  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) {
        if (res.freeOfChargeNm.length > 2) {
          this.freeOfChargeNm = res.freeOfChargeNm.substr(0, 2);
          this.freeOfChargeNm2 = res.freeOfChargeNm.substr(2, 2);
        }
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [START] */
  onPaymentsBeforeRouteCheck(frame: any) {
    const body = util.getWSData(frame);

    if (body.screen && body.screen != this.$route.meta) {
      this.$refs.updateShakenShuruiDialog.onOpen();
    } else {
      this.onPaymentsBeforeSettimeout(4000);
    }
  }

  onPaymentsBeforeSettimeout(msec: number = 1000) {
    setTimeout(() => {
      this.onPayments();
    }, msec);
  }

  get isShowJizen() {
    return this.isUserMode && (this.currentTab == 1) && this.checkIsCanJizen();
  }

  setLoadingShakenShurui(b: boolean) {
    if (this.isShowJizen) {
      this.$set(this, "loadingShakenShurui", b);
    }
  }
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */
}
